module.exports = __webpack_public_path__ + "static/media/mw.ea455181.svg";